import React from "react"
import ReactDOM from "react-dom/client"
import reportWebVitals from "./reportWebVitals"
import App from "./App"
import "../src/style.scss"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import store from "./store"
import { PersistGate } from "redux-persist/integration/react"
import { persistStore } from "redux-persist"
import { APIProvider } from "@vis.gl/react-google-maps"

const root = ReactDOM.createRoot(document.getElementById("root"))
let persistor = persistStore(store)
root.render(
  <React.StrictMode>
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </APIProvider>
  </React.StrictMode>
)

reportWebVitals()
